import { defineComponent, openBlock, createElementBlock, Fragment, renderList, unref, createBlock, resolveDynamicComponent, mergeProps } from "vue";
import { usePopoverController } from "./src/composables/usePopoverController/index.mjs";
import { _ as _sfc_main$1 } from "./floatingUi-B76xsVek.mjs";
import { _ as _sfc_main$2 } from "./BTooltip.vue_vue_type_script_setup_true_lang-Do0IxGJx.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BPopoverOrchestrator",
  setup(__props, { expose: __expose }) {
    const tools = usePopoverController();
    __expose({
      ...tools
    });
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList((_a = unref(tools).popovers) == null ? void 0 : _a.value, ([self, popover]) => {
          return openBlock(), createBlock(resolveDynamicComponent(popover.component ?? _sfc_main$1), mergeProps({
            key: self,
            ref_for: true
          }, popover.props, {
            "model-value": popover.props._modelValue,
            target: popover.props._target,
            "onUpdate:modelValue": ($event) => {
              var _a2, _b2;
              return (_b2 = (_a2 = unref(tools)).setPopover) == null ? void 0 : _b2.call(_a2, self, { ...popover.props, _modelValue: $event });
            }
          }), null, 16, ["model-value", "target", "onUpdate:modelValue"]);
        }), 128)),
        (openBlock(true), createElementBlock(Fragment, null, renderList((_b = unref(tools).tooltips) == null ? void 0 : _b.value, ([self, tooltip]) => {
          return openBlock(), createBlock(resolveDynamicComponent(tooltip.component ?? _sfc_main$2), mergeProps({
            key: self,
            ref_for: true
          }, tooltip.props, {
            "model-value": tooltip.props._modelValue,
            target: tooltip.props._target,
            "onUpdate:modelValue": ($event) => {
              var _a2, _b2;
              return (_b2 = (_a2 = unref(tools)).setTooltip) == null ? void 0 : _b2.call(_a2, self, { ...tooltip.props, _modelValue: $event });
            }
          }), null, 16, ["model-value", "target", "onUpdate:modelValue"]);
        }), 128))
      ], 64);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-DT9DiFfu.mjs.map
